import React, { Component } from 'react'
import {
  TheContent,
  TheSidebar,
  TheFooter,
  TheHeader
} from './index'
import {
  getrefreshtoken
} from '../services/fetchTools';
import Cookies from 'universal-cookie'

const cookies = new Cookies();

class TheLayout extends Component {
  componentDidMount() {
    this.cektoken();
  }
  async cektoken(){
    //console.log('layout cektoken')
    const token=await getrefreshtoken();
    let cookie=cookies.get('iSense_user')
    if (!cookie) {
      this.props.history.push({
        pathname: '/login'
      });
    }else{  
        cookie.refreshStatus="idle";          
        cookies.set('iSense_user', JSON.stringify(cookie), { path: '/' });  
      }
    // console.log('token',token)
  }
  render(){    
  return (
        <div className="c-app c-default-layout">
          <TheSidebar/>
          <div className="c-wrapper">
            <TheHeader/>
            <div className="c-body">
              <TheContent/>
            </div>
            <TheFooter/>
          </div>
        </div>
      )
    }
  }

export default TheLayout
